import { render } from "./PS1Variable.vue?vue&type=template&id=380163b1&scoped=true&ts=true"
import script from "./PS1Variable.vue?vue&type=script&lang=ts"
export * from "./PS1Variable.vue?vue&type=script&lang=ts"

import "./PS1Variable.vue?vue&type=style&index=0&id=380163b1&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380163b1"]])

export default __exports__